export const encode = data => {
	const formData = new FormData();

	for (const key of Object.keys(data)) {
		formData.append(key, data[key]);
	}

	return formData;
};

export const describe = key => {
	return key.charAt(0).toUpperCase() + key.slice(1);
};



// WEBPACK FOOTER //
// ./src/managers/formManager.js